import React from 'react';
import { ArrowRight, Sparkles, Camera } from 'lucide-react';

const CTA = ({ language }) => {
  const texts = {
    en: {
      title: 'Ready to Transform Your Kitchen?',
      subtitle: 'Join thousands of cooks who are discovering new recipes with AI every day',
      cta: 'Start Creating Recipes Now',
      features: [
        'Instant results',
        'Available 24/7',
        'AI-powered recipes'
      ]
    },
    pt: {
      title: 'Pronto para Transformar sua Cozinha?',
      subtitle: 'Junte-se a milhares de cozinheiros que descobrem novas receitas com IA todos os dias',
      cta: 'Comece a Criar Receitas Agora',
      features: [
        'Resultados instantâneos',
        'Disponível 24/7',
        'Receitas com IA'
      ]
    }
  };

  const t = texts[language];

  return (
    <section id="section-5" className="py-20 bg-gradient-to-br from-green-600 to-emerald-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-6">
              <Sparkles className="w-10 h-10 text-white" />
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              {t.title}
            </h2>
            
            <p className="text-xl text-green-100 max-w-3xl mx-auto mb-8">
              {t.subtitle}
            </p>
          </div>

          <div className="flex justify-center items-center mb-12">
            <a href="/s" className="bg-white text-green-600 px-8 py-4 rounded-xl font-semibold text-lg hover:bg-green-50 transition-colors duration-200 flex items-center space-x-2 shadow-lg">
              <Camera className="w-6 h-6" />
              <span>{t.cta}</span>
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-green-100">
            {t.features.map((feature, index) => (
              <div key={index} className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-green-300 rounded-full"></div>
                <span className="text-sm font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
